import React from 'react'
import PageHeadSection from '../admin/components/PageHeadSection'
import WarehousesList from './WarehousesList'
import SectionBoxContainer from '../../components/SectionBoxContainer'

interface IProps {
    hidePageHeadSection?: boolean,
    hidSectionBox?: boolean,
}

export default function WarehousesListPage(props: IProps) {
    
    const { 
        hidePageHeadSection, 
        hidSectionBox 
    } = props

    return(
        <div>
            {!hidePageHeadSection && <PageHeadSection pageName="warehouses" />}

            {hidSectionBox ? <WarehousesList />: <SectionBoxContainer><WarehousesList /></SectionBoxContainer>}
        </div>
    )
}